import { render, staticRenderFns } from "./UserTabs.vue?vue&type=template&id=7a2a4f43&scoped=true"
import script from "./UserTabs.vue?vue&type=script&lang=js"
export * from "./UserTabs.vue?vue&type=script&lang=js"
import style0 from "./UserTabs.vue?vue&type=style&index=0&id=7a2a4f43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2a4f43",
  null
  
)

export default component.exports